export const BUS_DEPARTMENTS_CHANGED = 'bus-departments-changed'